import React from "react";

import { IWithRouteNavigatorWrapped, withRouteNavigator } from "@/infrastructure/Route";

import { INavItemProps, NavItem } from "./NavItem";

import "./_route-nav-item.scss";

interface Props extends Omit<INavItemProps, "onClick">, IWithRouteNavigatorWrapped {
  target?: "_blank" | "_self";
}

export const NavItemComponent: React.FunctionComponent<Props> = React.memo(
  ({ onClick, href, testName, target = "_self", ...navItemProps }) => {
    const baseClass = "route-nav-item";

    return (
      <a
        href={href}
        onClick={onClick}
        className={baseClass}
        target={target}
        {...(target === "_blank" && { rel: "noopener noreferrer" })}>
        <NavItem {...navItemProps} />
      </a>
    );
  },
);

export const RouteNavItem = withRouteNavigator(NavItemComponent);
